import React from 'react'
import {Container, StartProcedureCard} from 'features/procedures/StartProcedureCard'
import queryString from 'query-string'

const ChooseUseOrCreate = ({location: {search}}) => {
  const {employee_id} = queryString.parse(search)

  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">進め方を選択</h1>
      </div>
      <Container>
        <StartProcedureCard to={`/extend_maternity/choose_procedure?employee_id=${employee_id}`} variant="start">
          過去の手続き情報を利用
        </StartProcedureCard>
        <StartProcedureCard to={`/extend_maternity/detail?employee_id=${employee_id}`} variant="start">
          手続きの新規作成
        </StartProcedureCard>
      </Container>
    </div>
  )
}
export default ChooseUseOrCreate
